
<template>
  <div>
    <div style="display:flex">
      <AdminHeader v-bind:menu_id="'4-2'"/>
      <div class="Admin_PageBox">
        <div class="Admin_PageHeader">
          <p>여행 관리 - 여행상품 관리</p>
          <div class="Admin_PageHeader_btn">
            <router-link to="/AdminTravelProductManagementAdd" class="Admin_PageHeader_btn01">등록</router-link>
            <button class="Admin_PageHeader_btn02" v-on:click="edit">수정</button>
            <button class="Admin_PageHeader_btn03" v-on:click="copy_row">복제하기</button>
            <!-- <button class="Admin_PageHeader_btn03" v-on:click="delete_row">삭제</button> -->
          </div>
        </div>

        <div class="Admin_PageInner">
          <div class="Admin_PageInfo">
            <p>사용 방법 안내</p>
            <p>1. 리스트 정렬은 ID와 상관없이 순서대로이며, 상단이 우선 순위가 높습니다.</p>
            <p>2. 왼쪽 3선 작대기를 클릭&드래그하여 위/아래로 이동할 수 있습니다.</p>
            <p>3. 순서정렬 시 검색조건에서 여행타입 구분을 지정한 다음 순서를 정하셔야 합니다.</p>
            <p>4. 삭제는 안되며 수정 버튼을 통해 사용 여부를 미사용으로 활용하면 됩니다.</p>
          </div>
          <button @click="toggleSearchPanel" class="Admin_toggleSearch_openBtn">
            검색
          </button>
          <div class="Admin_toggleSearchWrap" v-if="isPanelVisible">
            <div class="Admin_toggleSearcTit">
              <p>검색조건</p>
              <button class="Admin_toggleSearch_closeBtn" @click="toggleSearchPanel"></button>
            </div>
            <div class="Admin_toggleSearcBox">
              <label for="TravelTypeDivision">여행타입 구분</label>
              <select id="TravelTypeDivision" v-model="selectTravelTypeDivision">
                <option value=''>선택하세요.</option>
                <option value='1'>국악와인열차</option>
                <option value='2'>팔도장터열차</option>
                <option value='3'>일반기차여행</option>
                <option value='4'>버스/자유여행</option>
                <option value='5'>섬/제주/해외여행</option>
              </select>
            </div>
            <div class="Admin_toggleSearcBox">
              <label for="travelProductName">여행상품명</label>
              <input
                  type='text'
                  id="travelProductName"
                  placeholder = "여행상품명을 입력해주세요."
                  v-model="travelProductName"
                  @keydown.enter="fetchDataWithParams"
                />
            </div>
            <button @click="fetchDataWithParams" class="Admin_toggleSearch_searchBtn">검색</button>
          </div>
          <div ref="table"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable camelcase */
import AdminHeader from '../Section/AdminHeader.vue'
import AdminFooter from '../Section/AdminFooter.vue'
import {TabulatorFull as Tabulator} from 'tabulator-tables'
import {
  get_travel_product,
  update_travel_product_order,
  delete_travel_product,
  copy_travel_product
} from '../../ETC/Axios.vue'

export default {
  name: 'AdminTravelProductManagement',
  components: {
    AdminHeader,
    AdminFooter
  },
  data () {
    return {
      tabulator: null,
      isPanelVisible: false,
      selectTravelTypeDivision: '',
      travelProductName: '',
      lastSearchedDivision: ''
    }
  },
  methods: {
    edit: function () {
      if (this.tabulator.getSelectedData().length > 1) {
        alert('수정할 데이터를 하나만 선택해주세요.')
      } else if (this.tabulator.getSelectedData().length === 0) {
        alert('수정할 데이터를 선택해주세요.')
      } else {
        window.location.href = `/AdminTravelProductManagementAdd?travel_product_ID=${this.tabulator.getSelectedData()[0].travel_product_ID}`
      }
    },
    delete_row: function () {
      let temp_delete_array = []
      this.tabulator.getSelectedData().forEach((element) => {
        temp_delete_array.push(element.travel_product_ID)
      })
      delete_travel_product(temp_delete_array).then((result) => {
        if (result === undefined) {
          alert('삭제가 되지 않았습니다. 관리자한테 확인해주세요.')
        } else {
          alert('삭제가 완료 되었습니다.')
          window.location.reload()
        }
      })
    },
    toggleSearchPanel: function () {
      this.isPanelVisible = !this.isPanelVisible
    },
    fetchDataWithParams: function () {
      const params = {
        travel_type_division: this.selectTravelTypeDivision,
        travel_product_name: this.travelProductName
      }
      get_travel_product(params).then(result_data => {
        this.tabulator.setData(result_data)
        this.tabulator.setPage(1)
        this.lastSearchedDivision = this.selectTravelTypeDivision
      })
    },
    copy_row: function () {
      let temp_copy_array = []
      if (this.tabulator.getSelectedData().length === 0) {
        alert('복제할 리스트를 선택해주세요.')
      } else {
        this.tabulator.getSelectedData().forEach((element) => {
          temp_copy_array.push(element.travel_product_ID)
        })
        copy_travel_product(JSON.stringify(temp_copy_array)).then((result) => {
          if (result === undefined) {
            alert('복제가 되지 않았습니다. 관리자한테 확인해주세요.')
          } else {
            alert('복제가 완료 되었습니다.')
            window.location.reload()
          }
        })
      }
    }
  },
  mounted () {
    const params = {
      travel_type_division: this.selectTravelTypeDivision,
      travel_product_name: this.travelProductName
    }
    get_travel_product(params).then(result_data => {
      this.tabulator = new Tabulator(this.$refs.table, {
        data: result_data,
        layout: 'fitData',
        movableRows: true,
        pagination: 'local',
        paginationSize: 100,
        paginationButtonCount: 5,
        columns: [
          {rowHandle: true, formatter: 'handle', headerSort: false, frozen: true, width: 30, minWidth: 30},
          {formatter: 'rowSelection',
            titleFormatter: 'rowSelection',
            headerSort: false,
            cellClick: function (e, cell) {
              cell.getRow().toggleSelect()
            }
          },
          {title: '여행상품ID', field: 'travel_product_ID', headerSort: false},
          {title: '여행타입 구분', field: 'travel_type_division', headerSort: false},
          {title: '여행타입명', field: 'travel_type_name', headerSort: false},
          {title: '여행상품명', field: 'travel_product_name', headerSort: false},
          {title: '여행기간', field: 'travel_period', headerSort: false},
          {
            title: '적립포인트',
            field: 'travel_product_point',
            headerSort: false,
            formatter: function (cell, formatterParams, onRendered) {
              return cell.getValue().toLocaleString() + 'P'
            }
          },
          {
            title: '최소출발인원',
            field: 'travel_product_minimum_departure',
            headerSort: false,
            formatter: function (cell, formatterParams, onRendered) {
              return cell.getValue() + '명'
            }
          },
          {title: '여행페이지 내 추천여부', field: 'travel_product_recommend_status', headerSort: false},
          {title: '메인표시 여부', field: 'travel_product_main_status', headerSort: false},
          {title: '사용여부', field: 'travel_product_status', headerSort: false},
          {title: '등록 일자', field: 'travel_product_registe', headerSort: false},
          {title: '수정 일자', field: 'travel_product_modified', headerSort: false}
        ]
      })
      this.tabulator.on('rowMoved', (row) => {
        if (this.selectTravelTypeDivision !== '' && this.selectTravelTypeDivision === this.lastSearchedDivision) {
          let temp_travel_product_order_array = []
          let travel_product_order = 0
          const table = row.getTable()
          table.getRows().forEach(element => {
            temp_travel_product_order_array.push({
              travel_product_order: travel_product_order,
              travel_product_ID: element._row.data.travel_product_ID
            })
            travel_product_order++
          })
          update_travel_product_order(temp_travel_product_order_array).then(result => {
            if (result === undefined) {
              alert('순서가 변경되지 않았습니다. 관리자한테 확인해주세요.')
            }
          })
        } else {
          alert('검색조건에서 여행타입 구분을 지정하고 검색해야 순서를 변경할 수 있습니다.')
        }
      })
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/TravelManagement/AdminTravelProductManagement.vue